import { render, staticRenderFns } from "./message_dialog.vue?vue&type=template&id=6a1da8cc&scoped=true&"
import script from "./message_dialog.vue?vue&type=script&lang=js&"
export * from "./message_dialog.vue?vue&type=script&lang=js&"
import style0 from "./message_dialog.vue?vue&type=style&index=0&id=6a1da8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1da8cc",
  null
  
)

export default component.exports